import { Country } from "./../../models/country";
import { Component, OnDestroy, QueryList, ViewChildren } from "@angular/core";
import { Value } from "../../models/value";
import { ProgramArticleService } from "../../services/program-article.service";
import { Channel } from "../../models/channel";
import { FiltersService } from "../../services/filters.service";
import { Store } from "@ngrx/store";
import {
  FiltersActions,
  FiltersStateInterface,
} from "../../store/actions/filters.actions";
import { MdDialog } from "@angular/material";
import { User } from "../../models/user";
import { Subscription } from "rxjs/Subscription";
import { ListSelectorComponent } from "../../components/list-selector/list-selector.component";
import { INITIAL_FILTERS_STATE } from "../../store/reducers/filters.reducer";
import * as _ from "lodash";
import { ProgramArticlesActions } from "../../store/actions/program-articles.actions";
import { Router } from "@angular/router";
import { NgModel } from "@angular/forms";
import { ReferentialEntity } from "../../models/referential-entity";
import { SuccessComponent } from "../success/success.component";

@Component({
  selector: "app-filters-modal",
  templateUrl: "./filters-modal.component.html",
  styleUrls: ["./filters-modal.component.scss"],
})
export class FiltersModalComponent implements OnDestroy {
  referentialTypes: Value[];
  allStatus: Value[];
  allFields: Value[];
  allDestinations: Value[];
  allTypes: Value[];
  allAffiliates: Value[];
  allTierings: Value[];
  loading: boolean;
  channels: Channel[];
  linearChannels: Channel[];
  bonusChannels: Channel[];
  startDate: Date;
  endDate: Date;
  filters: FiltersStateInterface;
  subscriptions: Subscription[];
  user: User;
  limit = 5 * 1000 * 60 * 60 * 24 * 7;
  weekNbDays = 1000 * 60 * 60 * 24 * 6;
  countries: Country[];
  isNonSportiveClassif: boolean;
  midnightMode: boolean;
  idValueValid: boolean;

  regexNumber: string;
  regexBroadcastId: string;
  regexSpevId: string;
  regexProductCode: string;

  @ViewChildren("selector") selectors: QueryList<ListSelectorComponent>;

  /**
   * Initialize variables and load data from store and API
   * @param {ProgramArticleService} programArticleService
   * @param {ChannelService} channelService
   * @param {FiltersService} filtersService
   * @param {FiltersActions} filtersActions
   * @param {MdDialog} mdDialog
   * @param {Store<any>} store
   */
  constructor(
    private programArticleService: ProgramArticleService,
    private filtersService: FiltersService,
    private programArticlesActions: ProgramArticlesActions,
    private filtersActions: FiltersActions,
    private mdDialog: MdDialog,
    private router: Router,
    private store: Store<any>
  ) {
    this.subscriptions = [];

    this.regexNumber = "^([0-9]+)?$";
    this.regexBroadcastId = "^([e][0-9]+[c][0-9]+(ch)[0-9]+)?$";
    this.regexSpevId = "^([0-9]+((/)[0-9]+)?)?$";
    this.regexProductCode = "^([A-Z]{4}[0-9]+)?$";
    this.loading = true;
    this.filters = null;
    this.isNonSportiveClassif = false;
    this.midnightMode = false;
    this.idValueValid = true;

    /**
     * Load filters from filters store state
     */
    this.subscriptions.push(
      this.store
        .select("filtersState")
        .subscribe((filters: FiltersStateInterface) => {
          this.filters = _.cloneDeep(filters);
          this.filters.year = this.filters.startDate.getFullYear();
          this.filtersService.selectedReferentialEntities =
            filters.referentialEntities;
        })
    );

    /**
     * Load user from filters store state and load channels user from API
     */
    this.subscriptions.push(
      this.store.select("userState").subscribe((user: User) => {
        if (user && user.currentLanguage) {
          this.filters.languageId = user.currentLanguage.id;
          this.user = user;
        }
      })
    );

    /**
     * Get channels from localstorage, if not found, get from API and save it in localstorage
     */
    this.channels = JSON.parse(localStorage.getItem("channels"));
    this.linearChannels = JSON.parse(localStorage.getItem("channels")).filter(
      (c) => c.isMain
    );
    this.bonusChannels = JSON.parse(localStorage.getItem("channels")).filter(
      (c) => !c.isMain
    );

    /**
     * Show the Non Sportive Classif first if Type,Group or Label filters are used
     */
    if (this.filters) {
      if (
        this.filters.referentialEntities &&
        this.filters.referentialEntities.length > 0
      ) {
        this.filters.referentialEntities.forEach((refEntities) => {
          if (
            refEntities.referentialId === 7 ||
            refEntities.referentialId === 8 ||
            refEntities.referentialId === 9
          ) {
            this.isNonSportiveClassif = true;
            this.midnightMode = true;
          } else {
            this.isNonSportiveClassif = false;
          }
        });
      } else {
        this.isNonSportiveClassif = false;
      }
    } else {
      this.isNonSportiveClassif = false;
    }

    /**
     * Get referential from localstorage, if not found, get from API and save it in localstorage
     */

    if (this.isNonSportiveClassif) {
      if (!localStorage.getItem("nonSportiveReferentials")) {
        this.programArticleService
          .getReferentialTypes(this.isNonSportiveClassif)
          .subscribe((referentials) => {
            localStorage.setItem(
              "nonSportiveReferentials",
              JSON.stringify(referentials)
            );
            this.referentialTypes = referentials;
          });
      }
      this.referentialTypes = JSON.parse(
        localStorage.getItem("nonSportiveReferentials")
      );
    } else {
      if (!localStorage.getItem("sportiveReferentials")) {
        this.programArticleService
          .getReferentialTypes(this.isNonSportiveClassif)
          .subscribe((referentials) => {
            localStorage.setItem(
              "sportiveReferentials",
              JSON.stringify(referentials)
            );
            this.referentialTypes = referentials;
          });
      }
      this.referentialTypes = JSON.parse(
        localStorage.getItem("sportiveReferentials")
      );
    }

    /**
     * Get fieldStatus from localstorage, if not found, get from API and save it in localstorage
     */
    if (!localStorage.getItem("fieldStatus")) {
      this.programArticleService.GetFieldsStatus().subscribe((fieldStatus) => {
        localStorage.setItem("fieldStatus", JSON.stringify(fieldStatus));
        this.allStatus = fieldStatus;
      });
    }
    this.allStatus = JSON.parse(localStorage.getItem("fieldStatus"));
    if (!this.filters.fieldStatus) {
      this.filters.fieldStatus = this.allStatus[0].value;
    }

    /**
     * Get fields from localstorage, if not found, get from API and save it in localstorage
     */
    if (!localStorage.getItem("fields")) {
      this.programArticleService.GetFields().subscribe((fields) => {
        localStorage.setItem("fields", JSON.stringify(fields));
        this.allFields = fields;
      });
    }
    this.allFields = JSON.parse(localStorage.getItem("fields"));
    if (!this.filters.field) {
      this.filters.field = this.allFields[0].value;
    }

    /**
     * Get destinations from localstorage, if not found, get from API and save it in localstorage
     */
    this.allDestinations = JSON.parse(localStorage.getItem("destinations"));
    if (!this.filters.filterDestination) {
      this.filters.filterDestination = this.allDestinations[0].value;
    }

    /**
     * Get types from localstorage, if not found, get from API and save it in localstorage
     */
    if (!localStorage.getItem("types")) {
      this.programArticleService.GetIdTypes().subscribe((types) => {
        localStorage.setItem("types", JSON.stringify(types));
        this.allTypes = types;
      });
    }
    this.allTypes = JSON.parse(localStorage.getItem("types"));
    if (!this.filters.idType) {
      this.filters.idType = this.allTypes[0].value;
    }

    /**
     * Get affiliates from localstorage, if not found, get from API and save it in localstorage
     */
    if (!localStorage.getItem("affiliates")) {
      this.programArticleService.GetAffiliates().subscribe((affiliates) => {
        localStorage.setItem("affiliates", JSON.stringify(affiliates));
        this.allAffiliates = affiliates;
      });
    }
    this.allAffiliates = JSON.parse(localStorage.getItem("affiliates"));
    if (this.filters.idType === "6") {
      this.filters.idValue = "" + this.allAffiliates[0].id;
    }

    /**
     * Get tierings from localstorage, if not found, get from API and save it in localstorage
     */
    if (!localStorage.getItem("tierings")) {
      this.programArticleService.GetTierings().subscribe((tierings) => {
        localStorage.setItem("tierings", JSON.stringify(tierings));
        this.allTierings = tierings;
      });
    }
    this.allTierings = JSON.parse(localStorage.getItem("tierings"));
    if (this.filters.idType === "7") {
      this.filters.idValue = "" + this.allTierings[0].id;
    }

    /**
     * Load countries from localstorage
     */
    this.countries = JSON.parse(localStorage.getItem("countries"));
    if (
      !this.filters.broadcastingCountries ||
      this.filters.broadcastingCountries.length === 0
    ) {
      this.filters.broadcastingCountries = this.countries.filter(
        (c) => c.isChecked
      );
    } else {
      this.filters.broadcastingCountries = this.countries.filter((c) =>
        this.filters.broadcastingCountries.find((bc) => bc.id === c.id)
      );
    }

    this.loading = false;

    if (this.filters) {
      if (
        this.filters.referentialEntities &&
        this.filters.referentialEntities.length > 0
      ) {
        this.filters.referentialEntities.forEach((refEntities) => {
          if (refEntities.referentialId === 7) {
            this.isNonSportiveClassif = true;
          } else {
            this.isNonSportiveClassif = false;
          }
        });
      } else {
        this.isNonSportiveClassif = false;
      }
    } else {
      this.isNonSportiveClassif = false;
    }
  }

  /**
   * On destroy event, clear the referential entities and unsubscribe the subscriptions
   */
  ngOnDestroy() {
    this.filtersService.clear();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /**
   * Check if the channel is checked
   * @param {Channel} channel
   * @returns {Channel | undefined}
   */
  isChecked(channel: Channel) {
    return this.filters.channels.find((c) => c.id === channel.id);
  }

  /**
   * Add or remove channel from the filter's channel
   * @param event
   */
  channelToggleEvent(event) {
    if (this.filters.channels.find((c) => c.id === event.id)) {
      this.filters.channels = this.filters.channels.filter(
        (c) => c.id !== event.id
      );
    } else {
      this.filters.channels.push(event);
    }
  }

  /**
   * Select all channels
   */
  selectAllLinearChannels() {
    this.clearLinearChannels();
    this.linearChannels.forEach((c) => {
      this.filters.channels.push(c);
    });
  }

  /**
   * Select all channels
   */
  selectAllBonusChannels() {
    this.clearBonusChannels();
    this.bonusChannels.forEach((c) => {
      this.filters.channels.push(c);
    });
  }

  /**
   * Deselect all channels
   */
  clearLinearChannels() {
    this.filters.channels = this.filters.channels.filter(
      (c) => c.isMain == false
    );
  }

  /**
   * Deselect all channels
   */
  clearBonusChannels() {
    this.filters.channels = this.filters.channels.filter(
      (c) => c.isMain == true
    );
  }

  checkNumberId() {
    // check if number id is selected and valid
    this.filters.idValue = this.filters.idValue.trim();
    this.idValueValid =
      this.filters.idType !== "BroadcastId" &&
      this.filters.idType !== "SpevId" &&
      this.filters.idType !== "Affiliate" &&
      RegExp(this.regexNumber).test(this.filters.idValue);
  }

  checkBroadcastId() {
    // check if broadcast id is selected and valid
    this.filters.idValue = this.filters.idValue.trim();
    this.idValueValid =
      this.filters.idType === "BroadcastId" &&
      RegExp(this.regexBroadcastId).test(this.filters.idValue);
  }

  checkSpevId() {
    // check if spev id is selected and valid
    this.filters.idValue = this.filters.idValue.trim();
    this.idValueValid =
      this.filters.idType === "SpevId" &&
      RegExp(this.regexSpevId).test(this.filters.idValue);
  }

  checkProductCode() {
    // check if product code is selected and valid
    this.filters.idValue = this.filters.idValue.toUpperCase().trim();
    this.idValueValid =
      this.filters.idType === "ProductCode" &&
      RegExp(this.regexProductCode).test(this.filters.idValue);
  }

  /**
   * Save filters in the store
   */
  saveFilters() {
    this.filters.referentialEntities =
      this.filtersService.selectedReferentialEntities;
    this.filtersActions.setFilters(this.filters);
    this.programArticlesActions.setCurrentProgramArticle(null);
    this.router.navigate(["/program-articles"]);
    this.mdDialog.closeAll();
  }

  /**
   * Save custom filter for the current user
   */
  saveUserFilter() {
    this.filters.referentialEntities =
      this.filtersService.selectedReferentialEntities;
    this.filtersService.saveUserFilter(this.filters).subscribe((result) => {
      if (result.success) {
        this.mdDialog.open(SuccessComponent, {
          data: { message: "Filter has been saved" },
        });
      }
    });
  }

  /**
   * Get custom filter for the current user
   */
  getUserFilter() {
    this.filtersService.getUserFilter().subscribe((filter) => {
      if (filter.value != null) {
        this.filters.broadcastingCountries = this.countries.filter((x) =>
          filter.value.filter_Broadcast.find(
            (y) => y.broadcastCountry == x.value
          )
        );

        this.filters.channels = this.linearChannels.filter((x) =>
          filter.value.filter_Channel.find((y) => y.channel_Id == x.id)
        );
        var channelsFiltered = this.filters.channels.concat(
          this.filters.channels,
          this.bonusChannels.filter((x) =>
            filter.value.filter_Channel.find((y) => y.channel_Id == x.id)
          )
        );
        this.filters.channels = channelsFiltered;

        // Get referentials
        this.selectors.forEach((x) => x.clearSelection());
        this.filtersService.clear();
        filter.value.filter_Referential.map((referential) => {
          if (
            this.filtersService.selectedReferentialEntities.find(
              (y) => y.id === referential.referential_Id
            ) == null
          ) {
            var referentialEntity = new ReferentialEntity({
              id: referential.referential_Id,
              name: referential.referential_Value,
              referentialId: referential.referential_Type,
            });
            this.selectors
              .find((x) => x.type.id == referential.referential_Type)
              .selectValue(referentialEntity);
          }
        });
        this.filters.referentialEntities =
          this.filtersService.selectedReferentialEntities;
      }
    });

    this.filtersActions.setFilters(this.filters);
  }

  /**
   * When start date change, check if the start date is lower than the end date and if the period is lower than a week
   */
  startDateChanged() {
    if (this.filters.startDate) {
      if (this.filters.startDate.getTime() > this.filters.endDate.getTime()) {
        this.filters.endDate = this.filters.startDate;
      }
      if (
        this.filters.endDate.getTime() - this.filters.startDate.getTime() >
        this.limit
      ) {
        this.filters.endDate = new Date(
          this.filters.startDate.getTime() + this.limit
        );
      }
      this.filters.year = this.filters.startDate.getFullYear();
      this.filters.week = null;
    }
  }

  /**
   * When end date change, check if the start date is lower than the end date and if the period is lower than a week
   */
  endDateChanged() {
    if (this.filters.endDate.getTime() < this.filters.startDate.getTime()) {
      this.filters.startDate = this.filters.endDate;
    }
    if (
      this.filters.endDate.getTime() - this.filters.startDate.getTime() >
      this.limit
    ) {
      this.filters.startDate = new Date(
        this.filters.endDate.getTime() - this.limit
      );
    }
    this.filters.year = this.filters.startDate.getFullYear();
    this.filters.week = null;
  }

  yearChanged() {
    if (this.filters.year < 2000) {
      this.filters.year = 2000;
    }
    this.calculateWeek();
  }

  weekChanged() {
    if (this.filters.week < 1) {
      this.filters.week = 1;
    }
    if (this.filters.week > 53) {
      this.filters.week = 53;
    }
    this.calculateWeek();
  }

  calculateWeek() {
    if (this.filters.week && this.filters.year) {
      this.filters.startDate = this.getDateOfISOWeek(
        this.filters.week,
        this.filters.year
      );
      this.filters.endDate = new Date(
        this.filters.startDate.getTime() + this.weekNbDays
      );
    }
  }

  getDateOfISOWeek(w, y) {
    var simple = new Date(y, 0, 1 + (w - 1) * 7);
    var dow = simple.getDay();
    var ISOweekStart = simple;
    if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    return ISOweekStart;
  }

  dayStartChanged(event) {
    this.filters.midnightMode = event.checked;
  }

  showHiddenChanged(event) {
    this.filters.showHidden = event.checked;
  }

  /**
   * When force inter is checked, clear all the selectors
   */
  forceInterChanged() {
    this.selectors.forEach((selector) => selector.clearSelection());
    this.filtersService.clear();
  }

  /**
   * Reset all filters
   */
  resetFilters() {
    this.filters = INITIAL_FILTERS_STATE;
    this.filters.channels = JSON.parse(localStorage.getItem("channels")).filter(
      (channel) => channel.isMain
    );
    this.filters.keywords = "";
    this.filters.idValue = "";
    this.selectors.forEach((selector) => selector.clearSelection());
    this.filters.broadcastingCountries = this.countries.filter(
      (c) => c.isChecked
    );
  }

  /**
   * Check the state of the channels buttons by checking if all the channels for this button are checked
   * @param {string} field
   * @returns {boolean}
   */
  allAreChecked(field: string) {
    let res = true;
    if (!this.channels || this.channels.length === 0) {
      return false;
    }

    switch (field) {
      case "isBeam":
        this.channels
          .filter((channel) => channel.isBeam)
          .forEach((channel) => {
            if (!this.isChecked(channel)) {
              res = false;
            }
          });
        break;
      case "isBT":
        this.channels
          .filter((channel) => channel.isBT)
          .forEach((channel) => {
            if (!this.isChecked(channel)) {
              res = false;
            }
          });
        break;
      case "isLE":
        this.channels
          .filter((channel) => channel.isLE)
          .forEach((channel) => {
            if (!this.isChecked(channel)) {
              res = false;
            }
          });
        break;
      case "isLEXT":
        this.channels
          .filter((channel) => channel.isLEXT)
          .forEach((channel) => {
            if (!this.isChecked(channel)) {
              res = false;
            }
          });
        break;
      case "isMIPL":
        this.channels
          .filter((channel) => channel.isMIPL)
          .forEach((channel) => {
            if (!this.isChecked(channel)) {
              res = false;
            }
          });
        break;
      case "isTL":
        this.channels
          .filter((channel) => channel.isTL)
          .forEach((channel) => {
            if (!this.isChecked(channel)) {
              res = false;
            }
          });
        break;
    }
    return res;
  }

  /**
   * Check the state of the channels buttons by checking if all the channels for this button are checked
   * @param {string} field
   * @returns {boolean}
   */
  areBonusChannelsAvailable(field: string) {
    let res = true;
    switch (field) {
      case "isBeam":
        res = this.channels.filter((channel) => channel.isBeam).length > 0;
        break;
      case "isBT":
        res = this.channels.filter((channel) => channel.isBT).length > 0;
        break;
      case "isLE":
        res = this.channels.filter((channel) => channel.isLE).length > 0;
        break;
      case "isLEXT":
        res = this.channels.filter((channel) => channel.isLEXT).length > 0;
        break;
      case "isMIPL":
        res = this.channels.filter((channel) => channel.isMIPL).length > 0;
        break;
      case "isTL":
        res = this.channels.filter((channel) => channel.isTL).length > 0;
        break;
    }
    return res;
  }

  /**
   * Toggle all channels for a button (field)
   * @param {string} field
   */
  toggleAll(field: string) {
    if (this.allAreChecked(field)) {
      _.remove(this.filters.channels, (channel) => {
        return channel[field];
      });
    } else {
      this.filters.channels = _.union(
        this.filters.channels,
        this.channels.filter((channel) => channel[field])
      );
    }
  }

  allCountriesSelected() {
    return this.filters.broadcastingCountries.length === this.countries.length;
  }

  selectAllCountries(select: NgModel, values, event) {
    if (event.checked) {
      select.update.emit(values);
    } else {
      select.update.emit([]);
    }
  }

  changeValueUpdatedInTheLastHour(value: number) {
    this.filters.updatedInTheLastHours = value;
  }

  /**
   * Change Between Sportive/NonSportive Classification and clear the selectors to avoid invalid data
   */
  changeTypeClassification(event) {
    this.isNonSportiveClassif = event.checked;
    this.selectors.forEach((selector) => selector.clearSelection());
    this.filters.referentialEntities = [];
    this.programArticleService
      .getReferentialTypes(this.isNonSportiveClassif)
      .subscribe((types) => {
        this.referentialTypes = types;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/filters-modal/filters-modal.component.ts